module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "nav"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "nav-right nav-menu"
  }, [_c('span', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "button is-primary is-outlined",
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('span', [_vm._v("SAIR")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-left"
  }, [_c('a', {
    staticClass: "nav-item"
  }, [_c('img', {
    attrs: {
      "src": "/static/logo.png",
      "alt": "Bulma logo"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-54136ae4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Topbar.vue
// module id = 98
// module chunks = 2